export default __webpack_public_path__ + "static/media/AFTSlogo.3c398d39.svg";